/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantsTypeExcludingFcmMessageIdFcmTokenWithRelations } from './tenantsTypeExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<TenantWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface TenantExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    name: string;
    type: string;
    address1?: string;
    address2?: string;
    address3?: string;
    address4?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
    status: string;
    tenantsTypeId: number;
    tenantsType?: TenantsTypeExcludingFcmMessageIdFcmTokenWithRelations;
}

